import React from 'react';
import { getData, deleteData, } from '../../../core/HttpAction';
import Table from '../../../core/Table'; 
import {withRouter,Link} from 'react-router-dom';
const Url='/book-issue-return';

const CellColumn=({props,row})=>{
    return row.book_status==1 ?<Link to={`${props.match.url}ed/${row.book_issue_return_id}`}><span className="uk-badge">Return</span></Link>:'Returned';
};
const columns=[
    {
        key:'book_name',
        displayName:'Book Title'
    },  
    {
        key:'member_name',
        displayName:'Member Name'
    }, 
    {
        key:'member_type',
        displayName:'Member Type'
    },
    {
        key:'issue_date',
        displayName:'Issue Date'
    },
    {
        key:'return_date',
        displayName:'Return Date'
    },
    {
        key:'returned_date',
        displayName:'Due Date'
    },
    {
        key:'book_status',
        displayName:'Return Status',
        Cell:CellColumn
    },
    
];


  
class ListPage extends React.Component {
    constructor(props) {
        super(props);
        this.state={
            params:{
                search_term: '',
                startDate: '',
                endDate:'', 
                limit:10,
                page:1
            }, 
            data:[],
            preloader:true,
        };
        this.fetchData = this.fetchData.bind(this);  
        this.handleFetch = this.handleFetch.bind(this);  
        this.delete = this.delete.bind(this);  
    }
 
    componentDidMount(){
        this.fetchData();
    }

 
    fetchData(){
        getData(Url,this.state.params).then((res)=>{ 
            this.setState({data:res.data,preloader:false}); 
        });
    }

    handleFetch(params){
        this.setState({params:{...params},preloader:true},()=>{
            this.fetchData();
        });
    }

    delete(id){
        let page=1;
        this.setState({preloader:true,params:{...this.state.params,page}});
        deleteData(Url+'/'+id).then((res)=>{
            if(res.data.status===200){
                this.fetchData();
            }else{
                alert('Not delete');
                this.setState({preloader:false});
            }
        });   
    }
    render() {
        let {preloader,data}=this.state; 
        return (
            <Table
                data={data}
                handleFetch={this.handleFetch.bind(this)}
                preloader={preloader}
                permission="book-issue-return"
                title="Book Issue / Return"
                columns={columns}
                primaryKey="book_issue_return_id"
                addEditUrl={`${this.props.match.url}-action`} 
                delete={this.delete.bind(this)}
            /> 
        );
    }
}
 
export default  withRouter(ListPage); 



// WEBPACK FOOTER //
// ./src/components/Library/BookIssueReturn/index.js